export default __webpack_public_path__ + "static/media/homeLineupRightPolygon.967c5372.svg";